import Select from "./Select";
import SelectItem from "./SelectItem";
import SelectTrigger from "./SelectTrigger";
import SelectContent from "./SelectContent";
import SelectValue from "./SelectValue";
import { X } from 'lucide-react';

const ShiftTypesSelect = ({ value, onChange, label, onRemove, translations }) => (
    <div className="mb-2">
      <label className="text-sm text-gray-600">{label}</label>
      <div className="relative">
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className="w-full pr-10">
            <SelectValue placeholder={translations("form.schedule.select")} />
          </SelectTrigger>
          <SelectContent>     
            <SelectItem value="M">{translations("form.schedule.morning")}</SelectItem>
            <SelectItem value="T">{translations("form.schedule.afternoon")}</SelectItem>
            <SelectItem value="N">{translations("form.schedule.night")}</SelectItem>
          </SelectContent>
        </Select>
        <button
          onClick={onRemove}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1
                   text-gray-400 hover:text-red-500
                   rounded-full hover:bg-red-50 transition-colors"
          title="Delete Shift Type"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );

export default ShiftTypesSelect;